 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {readInlineData, useLazyLoadQuery} from 'react-relay'



const useSpotlightResults = (meetingRef) => {
  const meeting = readInlineData(
    graphql`
      fragment useSpotlightResults_meeting on RetrospectiveMeeting @inline {
        spotlightGroup {
          id
        }
        spotlightSearchQuery
      }
    `,
    meetingRef
  )
  const {spotlightGroup, spotlightSearchQuery = ''} = meeting
  const spotlightGroupId = _nullishCoalesce(_optionalChain([spotlightGroup, 'optionalAccess', _ => _.id]), () => ( ''))

  const spotlightSearchResults = useLazyLoadQuery(
    graphql`
      query useSpotlightResultsLocalQuery($reflectionGroupId: ID!, $searchQuery: String!) {
        viewer {
          similarReflectionGroups(
            reflectionGroupId: $reflectionGroupId
            searchQuery: $searchQuery
          ) {
            id
            reflections {
              id
              isViewerDragging
            }
          }
        }
      }
    `,
    {
      reflectionGroupId: spotlightGroupId || '',
      searchQuery: spotlightSearchQuery || ''
    },
    {fetchPolicy: 'store-only'}
  )
  const {viewer} = spotlightSearchResults
  const {similarReflectionGroups} = viewer
  return similarReflectionGroups
}

export default useSpotlightResults
